import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { SIGN_IN_FAILED } from "@thalamos/haven-common";

import { startSignInUrl } from "../../api/user/api.js";
import thalamosMark from "../../assets/img/thalamos-mark.svg";
import { consumeReturnTo } from "../../routing/returnTo.js";

export const SignInPage = () => {
  const { t } = useTranslation();
  const { search } = useLocation();

  // Validated here rather than passed through raw: the value reaches us from a
  // URL, and it ends up appended to an origin on the server side.
  const returnTo = consumeReturnTo(search);
  const failed = new URLSearchParams(search).get("error") === SIGN_IN_FAILED;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        p: 3,
      }}
    >
      <Stack
        spacing={4}
        alignItems="center"
        alignSelf="center"
        sx={{ flex: 1, justifyContent: "center", maxWidth: 420 }}
      >
        {/* The mark, not the lockup that spells the company's name: the
            heading below is the product's own name, and a second name set as
            large beside it leaves the page with two titles. Lettering-free, so
            it needs no light ground of its own.

            `alt` is empty because the mark is decorative — the byline below
            names the company in text, so describing it here would have a screen
            reader say it twice. */}
        <Stack spacing={1.5} alignItems="center">
          <Box
            component="img"
            src={thalamosMark}
            alt=""
            sx={{ width: 48, maxWidth: "100%", height: "auto" }}
          />
          <Typography variant="h4" component="h1" textAlign="center">
            {t("app.name")}
          </Typography>
          <Typography variant="body1" color="text.secondary" textAlign="center">
            {t("app.strapline")}
          </Typography>
        </Stack>
        {failed && <Alert severity="error">{t("auth.signInFailed")}</Alert>}
        <Button
          variant="contained"
          size="large"
          href={startSignInUrl(returnTo)}
        >
          {t("auth.signIn")}
        </Button>
      </Stack>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {t("app.attribution")}
      </Typography>
    </Box>
  );
};
